import { SegmentType } from '../../types/Segment/Type';
import { ElementType } from '../../types/Element/Type';
import { VideoSegment } from '../../types/RemotionPlayerConfigTypes/Segment/VideoSegment';
import { SEGMENTS_DEFAULT_COLOR } from '../../constants/colors';
import { Clip } from '../../types/clip-types';

export function createIntroVideoSegment(clip: Clip, introDuration: number): VideoSegment {
  return {
    id: 'intro',
    name: 'Intro',
    type: SegmentType.VIDEO,
    fromFrame: 0,
    toFrame: introDuration,
    details: {
      background: {
        type: 'COLOR',
        value: SEGMENTS_DEFAULT_COLOR
      }
    },
    scenes: [],
    video: {
      id: 'introVideo',
      name: 'Intro Video',
      type: ElementType.VIDEO,
      fromFrame: 0,
      toFrame: introDuration,
      details: {
        src: clip.asset_metadata.intro || '',
        altText: 'Intro Video',
        volume: [
          {
            value: 100,
            fromFrame: 0,
            toFrame: introDuration
          }
        ]
      },
      trim: [],
      style: {
        objectFit: 'cover',
        width: '100%',
        height: '100%'
      },
      containerStyle: {
        borderRadius: '0px',
        position: 'absolute',
        top: '0%',
        left: '0%',
        width: '100%',
        height: '100%'
      },
      isOriginalVideo: false
    }
  };
}
